import clsx from "clsx";
import React, { useMemo, useState } from "react";
import { DownloadIcon } from "@pd/pd-ui-kit";

import Popover from "~/shared/ui/Fields/Popover";
import Tooltip from "~/shared/ui/Fields/Tooltip";
import { getCandidateDownloadArchive } from "~/pages/CatalogApplications/catalogApi";
import { downloadBlob } from "~/shared/lib/downloadBlob";

import s from "./DocumentsArchiveDropdown.less";

const DOWNLOAD_LABEL = "Скачать архив документов";
const EMPTY_LIST_TOOLTIP = "Нет доступных архивов для скачивания";
const MENU_ICON_COLOR = "#495A64";

export type DocumentsArchiveSection = {
  id: string;
  name: string;
};

type DocumentsArchiveDropdownProps = {
  candidateId: string;
  legalPersonName: string;
  sections: DocumentsArchiveSection[];
};

const downloadArchive = async (
  response: Response,
  sectionName: string,
  legalPersonName: string,
) => {
  const safeLabel = legalPersonName.replace(/[\\/:*?"<>|]/g, "_");
  const safeSectionName = sectionName.replace(/[\\/:*?"<>|]/g, "_");

  await downloadBlob(
    response,
    `Архив документов ${safeSectionName} ${safeLabel}.zip`,
  );
};

const DocumentsArchiveDropdown: React.FC<DocumentsArchiveDropdownProps> = ({
  candidateId,
  legalPersonName,
  sections,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const popoverItems = useMemo(
    () =>
      sections.map((section) => ({
        label: section.name,
        value: section.id,
        icon: (
          <DownloadIcon size={16} fill={MENU_ICON_COLOR} viewBox="0 0 16 16" />
        ),
      })),
    [sections],
  );

  const isDisabled = isDownloading || !popoverItems.length;

  const handleSelect = async (selected: { label: string; value: string }) => {
    const section = sections.find((item) => item.id === selected.value);
    if (!section) return;

    try {
      setIsDownloading(true);
      const response = await getCandidateDownloadArchive(
        candidateId,
        section.id,
      );
      await downloadArchive(response, section.name, legalPersonName);
    } catch (error) {
      console.error("Ошибка при скачивании архива:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Tooltip text={popoverItems.length ? undefined : EMPTY_LIST_TOOLTIP}>
      <div
        className={clsx(s.wrapper, { [s.wrapperDisabled]: isDisabled })}
        onClick={(e) => e.stopPropagation()}
      >
        <Popover
          trigger="click"
          content={popoverItems}
          direction="left"
          menuTitle=""
          menuWidth={320}
          iconPosition="left"
          showSelected={false}
          onSelect={handleSelect}
        >
          <div className={s.trigger}>{DOWNLOAD_LABEL}</div>
        </Popover>
      </div>
    </Tooltip>
  );
};

export default DocumentsArchiveDropdown;
